<ng-container [formGroup]="parent">
  <ng-container formGroupName="header">
    <div class="col-lg-12 parent">
      <div class="row child">
        <p-card class="card-spacing-0">
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <div class="gray-bg-rounded">
                  <div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Template Name</label>
                      <p-select
                        pInputText
                        formControlName="templateId"
                        (change)="onTemplateSelection()"
                        [options]="templates"
                        optionValue="id"
                        optionLabel="name"
                        [filter]="true"
                        [showClear]="true">
                      </p-select>
                    </div>
                  </div>
                  <div *ngIf="displaySaleOrderSection">
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Sale Order Id</label>
                      <p-select
                        pInputText
                        formControlName="saleOrderId"
                        (change)="onPONumberSelection()"
                        [options]="poNumber"
                        [filter]="true"
                        [showClear]="true">
                      </p-select>
                    </div>
                  </div>
                  <div *ngIf="displayPoSection">
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">PO #</label>
                      <p-select
                        pInputText
                        formControlName="poNumber"
                        (change)="onPONumberSelection()"
                        [options]="poNumber"
                        [filter]="true"
                        [showClear]="true">
                      </p-select>
                    </div>
                  </div>
                  <div class="d-flex gap-2">
                    <div class="col-9" *ngIf="displayPoSection">
                      <div class="form-group has-float-label mb-2">
                        <label class="form-label">PO Revision #</label>
                        <input
                          pInputText
                          jniAutoCompleteBlocker
                          type="text"
                          class="form-control"
                          placeholder=""
                          formControlName="poNumberRevision" />
                      </div>
                    </div>
                    <div class="d-flex mt-3" *ngIf="displayRushRevisedSection">
                      <div class="d-flex gap-2">
                        <div class="d-flex gap-2 align-items-center">
                          <p-checkbox
                            id="firm1"
                            formControlName="rush"
                            (click)="onRushSelection($event)"
                            [binary]="true"
                            (blur)="logValidationErrors()" />
                          <label class="d-block form-check-label mt-1"
                            >Rush</label
                          >
                        </div>
                        <div class="d-flex gap-2 align-items-center">
                          <p-checkbox
                            id="firm1"
                            formControlName="revised"
                            [binary]="true"
                            (click)="onRevisedSelection($event)"
                            (blur)="logValidationErrors()" />
                          <label class="d-block form-check-label mt-1"
                            >Revised</label
                          >
                        </div>
                      </div>

                      <!-- <div
          class="mt-2"
          style="margin-left: 15px; cursor: pointer"
          *ngIf="emailButtonStatus"
        >
          <a class="has-link" (click)="onEmailPO()">Email</a>
        </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="gray-bg-rounded">
                  <div>
                    <div class="row">
                      <div class="col-6">
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Sender</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            placeholder=""
                            formControlName="sender" />
                        </div>
                      </div>
                      <div class="col-6">
                        <div class="form-group has-float-label mb-2">
                          <label class="form-label">Reply</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            class="form-control"
                            placeholder=""
                            formControlName="reply" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Subject</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        placeholder=""
                        formControlName="subject"
                        [disabled]="true"
                        [ngClass]="{ 'has-error': formErrors['subject'] }"
                        (blur)="logValidationErrors()" />

                      <span class="error-msg" *ngIf="formErrors['subject']">
                        {{ formErrors["subject"] }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div class="form-group has-float-label mb-2">
                      <label class="form-label">Additional Subject</label>
                      <input
                        pInputText
                        jniAutoCompleteBlocker
                        type="text"
                        class="form-control"
                        formControlName="additionalSubject"
                        (change)="onAdditionalSubject($event)"
                        (blur)="logValidationErrors()" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-card>
      </div>
    </div>
  </ng-container>
</ng-container>
